<template>
    <div class="row no-gutters">
        <div class="bill-image col-3">
            <img :src='billIcon' alt="">
        </div>

        <div class="bill-content col-9" :class="{ 'col-md-5' : bill }">

            <div class="bill-name-group">
                <div class="bill-name"><span v-if="bill && bill.id === 532 && group.id === 1">Unlimited </span>{{ group.name }}</div>
                <div class="bill-provider" v-if="bill">Provided by {{ bill.provider.name }}</div>
            </div>


            <button type="button" class="btn-text bill-learn" v-if="bill" @click="showLearnMore">Learn more</button>
            <button type="button" class="cta cta-secondary" v-else @click="showMultiModal">Choose your plan</button>
        </div>

        <div class="bill-footer col-12 col-md-4" v-if="bill">
            <div class="bill-footer-inner">
                <div class="bill-price">
                    <div v-if="bill.prices[0].price_per_housemate === 0" class="price-free">FREE</div>
                    <div v-else>£{{ parseFloat(bill.prices[0].price_per_housemate).toFixed(2) }}/month</div>
                    <div class="bill-price-sub">per housemate</div>
                </div>

                <input v-if="getGroupSelected" type="hidden" name="bills[]" :value="bill.id">

                <button type="button" class="btn-text ml-auto bill-button" v-text="buttonText" @click="$store.dispatch('quote/toggleBillSelected', bill.id)" v-if="!group.is_perk"></button>
            </div>
        </div>
    </div>
</template>

<script>
    import store from "../../../store";

    export default {
        name: "BillBody",

        props: {
            group: {
                type: Object,
                required: true
            }
        },

        methods: {

            showLearnMore() {
                // Show description if single bill or table if multi-bill group
                if(this.$props.group.bills.length === 1) {
                    this.showInfoModal();
                } else {
                    this.showMultiModal();
                }
            },

            showInfoModal() {
                store.commit('quote/showBillInfoModal', this.bill.id);
            },

            showMultiModal() {
                store.commit('quote/showBillCompareModal', this.$props.group.id);
            },

        },

        computed: {

            bill() {
                if(this.$props.group.bills.length === 1) {
                    return this.$props.group.bills[0];
                } else if(this.getGroupSelected) {
                    return this.getGroupSelected;
                } else {
                    return null;
                }
            },

            billIcon() {
                if(this.bill && this.bill.provider.logo_path) {
                    return this.bill.provider.logo_path;
                } else if(this.$props.group.logo_path) {
                    return this.$props.group.logo_path;
                }
            },

            buttonText() {
                if (this.$props.group.bills.length > 1) {
                    return 'Change Plan';
                }

                return this.getGroupSelected ? 'Remove' : 'Add Bill';
            },

            getGroupSelected() {
                return this.$store.getters['quote/getGroupSelected'](this.$props.group.id);
            }
        }
    }
</script>
